import {
  basicCacheKeys as TYPE_NAMES,
  localCacheKeyPrefix,
  localCacheDatas
} from '@/utils/cacheConfig'
import {
  getSpecificBasicData, getSpecificBasicDataFromCache
} from '@/utils/basicDataCache'
import Store from '@/store'
import { AdvanceSelect } from '@/utils/class/AdvanceSelect'

export default class CustomLabelUtils {
  constructor() {
  }

  static getLabel(cacheKey, sourceField = '', sourceValue, autoKey, receivable = null) {
    const item = this.getItem(cacheKey, sourceField, sourceValue)
    if (!item) {
      return ''
    }
    switch (cacheKey) {
      case TYPE_NAMES.basic_data_Company:
        return this.getPartnerLabel(item, autoKey, receivable)
      case TYPE_NAMES.basic_data_User:
        return this.getUserLabel(item, autoKey)
      case TYPE_NAMES.basic_data_PaymentTerm:
        return this.getPaymentTermLabel(item, autoKey)
      case TYPE_NAMES.basic_data_Seaport:
        return this.getPortLabel(item, autoKey)
      case TYPE_NAMES.basic_data_Airport:
        return this.getPortLabel(item, autoKey)
      case TYPE_NAMES.basic_data_RailwayStation:
        return this.getPortLabel(item, autoKey)
    }
  }

  /**
   * 在组件cargoAdvanceSelect.getLabel方法中，【TYPE_NAMES.basic_data_User】类型的根据常规规则取不到值时，会去取默认值
   * 比如：用户的中文名没有，会默认取英文名
   * @param cacheKey
   * @param sourceField
   * @param sourceValue
   * @param autoKey
   * @returns {string|*|string}
   */
  static getLabelWithDefault(cacheKey, sourceField = '', sourceValue, autoKey) {
    const item = this.getItem(cacheKey, sourceField, sourceValue)
    if (!item) {
      return ''
    }
    switch (cacheKey) {
      case TYPE_NAMES.basic_data_Company:
        return this.getPartnerLabel(item, autoKey)
      case TYPE_NAMES.basic_data_User:
        return this.getUserLabelWithDefault(item, autoKey)
      case TYPE_NAMES.basic_data_PaymentTerm:
        return this.getPaymentTermLabel(item, autoKey)
      case TYPE_NAMES.basic_data_Seaport:
        return this.getPortLabel(item, autoKey)
      case TYPE_NAMES.basic_data_Airport:
        return this.getPortLabel(item, autoKey)
      case TYPE_NAMES.basic_data_RailwayStation:
        return this.getPortLabel(item, autoKey)
    }
  }

  static getUserLabelWithDefault(item, autoKey) {
    const label = this.getUserLabel(item, autoKey)
    if (label) {
      return label
    }
    const advanceSelect = new AdvanceSelect(TYPE_NAMES.basic_data_User, null, null, null, { includeAllItem: false })
    const ownTagName = advanceSelect.getTagName()
    return item[ownTagName] !== '' ? item[ownTagName] : (item.englishName || '')
  }

  static getPartnerLabel(item, autoKey, receivable) {
    const configs = Store.state.settings.partnerLabelSettings
    const curConfig = configs.find(config => config.autoKey === autoKey)
    const label = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
    switch (label) {
      case 'englishName':
        return item.englishName
      case 'chineseName':
        return item.chineseName
      case 'sortNamePlusEnglishName':
        return `[${item.cnShortName}]${item.englishName}`
      case 'sortNamePlusChineseName':
        return `[${item.cnShortName}]${item.chineseName}`
      case 'shortNamePlusChineseName':
        return `[${item.shortName}]${item.chineseName}`
      case 'code':
        return item.cnShortName
      case 'shortName':
        return item.shortName
      case 'customerSupplierNoChineseName':
        if (receivable === null) {
          let customerSupplerNo = item.externalKeyCust
          if (item.externalKeyVend) {
            if (customerSupplerNo) {
              customerSupplerNo += '|' + item.externalKeyVend
            } else {
              customerSupplerNo += item.externalKeyVend
            }
          }
          return `[${customerSupplerNo}]${item.chineseName}`
        } else {
          if (receivable) {
            const customerSupplerNo = item.externalKeyCust
            return `[${customerSupplerNo}]${item.chineseName}`
          } else {
            const customerSupplerNo = item.externalKeyVend
            return `[${customerSupplerNo}]${item.chineseName}`
          }
        }
      case 'customerNoChineseName':
        return `[${item.externalKeyCust}]${item.chineseName}`
      case 'supplierNoChineseName':
        return `[${item.externalKeyVend}]${item.chineseName}`
      case 'threeCharacterCode':
        return `[${item.cnShortName}]${item.threeCharacterCode}`
    }
  }
  static getPortLabel(item, autoKey) {
    const configs = Store.state.settings.partnerLabelSettings
    const curConfig = configs.find(config => config.autoKey === autoKey)
    const label = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
    switch (label) {
      case 'englishName':
        return item.englishName
      case 'chineseName':
        return item.chineseName || item.englishName
      case 'sortNamePlusEnglishName':
        return `[${item.code}]${item.englishName}`
      case 'sortNamePlusChineseName':
        return `[${item.code}]${item.chineseName || item.englishName}`
      case 'code':
        return item.code
      case 'shortName':
        return item.chineseName || item.code
    }
  }
  static getUserLabel(item, autoKey) {
    const configs = Store.state.settings.partnerLabelSettings
    const curConfig = configs.find(config => config.autoKey === autoKey)
    const label = Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key])
    switch (label) {
      case 'englishName':
        return item.englishName
      case 'chineseName':
        return item.chineseName
      case 'sortNamePlusEnglishName':
        return `[${item.userId}]${item.englishName}`
      case 'sortNamePlusChineseName':
        return `[${item.userId}]${item.chineseName}`
      case 'englishNamePlusChineseName':
        return `[${item.englishName}]${item.chineseName}`
      case 'chineseNamePlusEnglishName':
        return `[${item.chineseName}]${item.englishName}`
    }
  }
  static getPaymentTermLabel(item, autoKey) {
    const configs = Store.state.settings.partnerLabelSettings
    const curConfig = configs.find(config => config.autoKey === autoKey)
    const label = curConfig ? Object.keys(curConfig).find(key => typeof curConfig[key] === 'boolean' && curConfig[key]) : 'name'
    switch (label) {
      case 'code':
        return item.code || ''
      case 'codePlusName':
        return item.code && item.name ? `[${item.code}]${item.name}` : (item.code || item.name || '')
      case 'localName':
        return item.localName || item.name || ''
      case 'name':
      default:
        return item.name || ''
    }
  }
  static getItem(cacheKey, sourceField = '', sourceValue) {
    let result = []
    if (cacheKey.startsWith(localCacheKeyPrefix)) {
      if (Object.prototype.hasOwnProperty.call(localCacheDatas, cacheKey)) {
        result = Array.from(localCacheDatas[cacheKey])
      }
    } else {
      result = getSpecificBasicDataFromCache(cacheKey)
    }
    if (!result || !result.length) {
      return null
    }
    const entity = result.find(item => {
      return item[sourceField] === sourceValue
    })
    if (entity) {
      return entity
    }
    return null
  }
}
